import React, { useEffect, useState } from 'react';
import { useParams } from 'react-router-dom';

const ProductDetail = () => {
const { productId } = useParams();
const [isLoaded, setIsLoaded] = useState(false);
const [isMobile, setIsMobile] = useState(window.innerWidth <= 768);

useEffect(() => {
setIsLoaded(true);

// Handle responsive description
const handleResize = () => {
  setIsMobile(window.innerWidth <= 768);
};

window.addEventListener('resize', handleResize);
return () => window.removeEventListener('resize', handleResize);
}, []);

const truncateDescription = (description, maxLength = 100) => {
if (description.length <= maxLength) return description;
return description.substr(0, maxLength) + '...';
};

const products = [ 
{ id: 'RUT956', name: 'RUT956', image: '/product.png', features: ['4G/LTE (Cat 4)', '3G, 2G', 'IP55', 'PoE-In/Out'],
description: 'RUT956 is an industrial router that combines cellular, Wi-Fi, and wired connectivity options with automatic WAN failover and GNSS capabilities. Serial communication interfaces enable integrating more varied devices into the solution ecosystem, while I/O and advanced RutOS software facilitate equipment control, automation, and event notifications. ',
specifications: { CONNECTIVITY: '4G LTE (Cat 4), 3G, 2G',
DUALSIM: 'With auto failover, backup WAN and other switching scenarios',
MULTIPLEINTERFACES: 'Ethernet, Serial (RS232, RS485) and multiple Inputs/Outputs',
GNSS: 'Global Navigation Satellite System for location services and time synchronization' } },

{ id: 'RUT241', name: 'RUT241', image: '/rut241-1.png',
features: ['2 x Ethernet ports', 'Wi-Fi', 'Integrated DIN rail'],
description: 'Equipped with 4G LTE, Wi-Fi, and two Ethernet ports, RUT241 offers unstoppable connection continuity with automatic WAN failover. Industrial design, compact size, multiple connection interfaces, and compatibility with RMS make this device an excellent fit in numerous IoT and M2M solutions.',
specifications: { CONNECTIVITY: '4G LTE (Cat 4), 3G, 2G',
WIFI: 'Wireless access point with Hotspot functionality',
WANFAILOVER: 'Automatic switching to available backup connection',
RMS: 'For remote management, access & VPN services'} },

{ id: 'RUTm50', name: 'RUTm50', image: '/product3.png',
features: ['2 x Ethernet ports', 'Wi-Fi', 'Integrated DIN rail', 'RS232'], 
description: 'RUTM50 is an FCC-certified Teltonika Networks cellular 5G router for North America, with ultra-high cellular speeds of up to 3.4 Gbps. This dual SIM router has auto-failover and backup WAN and supports both SA and NSA 5G architectures. It is also backward compatible with 4G (LTE Cat 19/18), making it perfect for future-proofing your industrial networking solutions. ',
specifications: { CONNECTIVITY: '4G LTE (Cat 4), 3G, 2G', 
DUALSIM: 'Auto-failover, backup WAN, and other switching scenarios',
SANSA: 'Supports both SA & NSA 5G architectures',
FUTUREPROOFING: 'Backward compatible with 4G (LTE Cat 19/18)'} },

{ id: 'RUT241 eSIM', name: 'RUT240', image: '/product4.png',
features: ['4G LTE', 'Dual SIM', 'Wi-Fi', 'GPS'], 
description: 'The RUT241 eSIM variant offers enhanced connectivity options with embedded SIM capability.', 
specifications: { wireless: '4G LTE', ethernet: '2 x LAN', powerSupply: '9-30 VDC', dimensions: '83 x 74 x 25mm' } },

{ id: 'RUT241_eSIM', name: 'RUT241 eSIM', image: '/product4.png',
features: ['4G/LTE (Cat 4)', '3G, 2G', 'IP55', 'PoE-In/Out'], 
description: 'The RUT241 eSIM™ is an industrial cellular router equipped with LTE Cat 4 and eSIM™ with SGP.22 pull-based consumer architecture. This compact eSIM™ router supports a physical SIM card, up to seven eSIM™ profiles, controlled via WebUI and RMS, and Trusted Platform Module (TPM) for enhanced security. The RUT241 eSIM™ router provides undisrupted connectivity with automatic WAN failover and two Ethernet ports, making it perfect for your M2M and IoT solutions.', 
specifications: { CONNECTIVITY: '4G LTE (Cat 4), 3G, 2G', 
eSIM: 'Seamless connectivity with eSIM™ SGP.22',
TPM: 'Next-gen router security with Trusted Platform Module',
RMS: 'For easy & convenient eSIM™ profile management'} },
];

const styles = {
mainContainer: {
width: '100%',
minHeight: '100vh',
position: 'relative',
color: '#ffffff',
backgroundImage: 'url("https://images.unsplash.com/photo-1451187580459-43490279c0fa?q=80&w=2072&auto=format&fit=crop")',
backgroundSize: 'cover',
backgroundPosition: 'center',
backgroundRepeat: 'no-repeat',
backgroundAttachment: 'fixed',
overflow: 'hidden'
},
overlay: {
position: 'absolute',
top: 0,
left: 0,
right: 0,
bottom: 0,
backgroundColor: 'rgba(10, 25, 47, 0.85)',
zIndex: 1
},
content: {
position: 'relative',
zIndex: 2,
maxWidth: '1200px',
margin: '0 auto',
padding: '40px 20px',
opacity: isLoaded ? 1 : 0,
transform: isLoaded ? 'translateY(0)' : 'translateY(20px)',
transition: 'opacity 0.8s ease-out, transform 0.8s ease-out'
},
productGrid: {
display: 'grid',
gridTemplateColumns: 'repeat(2, 1fr)',
gap: '40px',
alignItems: 'center',
'@media (max-width: 768px)': {
gridTemplateColumns: '1fr',
gap: '20px'
}
},
textContent: {
display: 'flex',
flexDirection: 'column',
gap: '20px',
opacity: isLoaded ? 1 : 0,
transform: isLoaded ? 'translateX(0)' : 'translateX(-20px)',
transition: 'opacity 0.8s ease-out 0.2s, transform 0.8s ease-out 0.2s'
},
title: {
fontSize: '3.5rem',
fontWeight: 'bold',
margin: '0',
background: 'linear-gradient(45deg, #ffffff, #94a3b8)',
WebkitBackgroundClip: 'text',
WebkitTextFillColor: 'transparent',
'@media (max-width: 768px)': {
fontSize: '2rem',
textAlign: 'center'
}
},
subtitle: {
fontSize: '1.2rem',
color: 'white',
margin: '0',
'@media (max-width: 768px)': {
fontSize: '1rem',
textAlign: 'center'
}
},
description: {
fontSize: '1rem',
lineHeight: '1.6',
color: 'white',
'@media (max-width: 768px)': {
textAlign: 'center',
fontSize: '0.9rem'
}
},
mobileDescription: {
cursor: 'pointer',
textDecoration: 'underline'
},
imageContainer: {
position: 'relative',
width: '100%',
height: '400px',
opacity: isLoaded ? 1 : 0,
transform: isLoaded ? 'translateX(0)' : 'translateX(20px)',
transition: 'opacity 0.8s ease-out 0.4s, transform 0.8s ease-out 0.4s',
'@media (max-width: 768px)': {
height: '300px'
}
},
productImage: {
width: '100%',
height: '100%',
objectFit: 'contain',
position: 'relative',
zIndex: 2,
animation: 'float 6s ease-in-out infinite'
},
'@keyframes float': {
'0%, 100%': {
transform: 'translateY(0)'
},
'50%': {
transform: 'translateY(-20px)'
}
},
shadowImage: {
position: 'absolute',
top: '10%',
left: '10%',
width: '100%',
height: '100%',
objectFit: 'contain',
opacity: 0.4,
filter: 'blur(10px)',
zIndex: 1
},
specificationsGrid: {
display: 'grid',
gridTemplateColumns: 'repeat(auto-fit, minmax(250px, 1fr))',
gap: '20px',
marginTop: '10px',
padding: '20px',
borderRadius: '12px',
backdropFilter: 'blur(10px)',
opacity: isLoaded ? 1 : 0,
transform: isLoaded ? 'translateY(0)' : 'translateY(20px)',
transition: 'opacity 0.8s ease-out 0.6s, transform 0.8s ease-out 0.6s',
'@media (max-width: 768px)': {
gridTemplateColumns: '1fr'
}
},
mobileDescription: {
  cursor: 'pointer',
  textDecoration: 'underline'
},
specificationCard: {
backgroundColor: 'rgba(30, 41, 59, 0.5)',
padding: '20px',
borderRadius: '8px',
border: '1px solid rgba(148, 163, 184, 0.1)',
transition: 'transform 0.3s ease-out, box-shadow 0.3s ease-out',
cursor: 'pointer',
':hover': {
transform: 'translateY(-5px)',
boxShadow: '0 4px 20px rgba(0, 0, 0, 0.3)'
}
},
specTitle: {
color: 'white',
fontSize: '0.9rem',
fontWeight: 'bold',
marginBottom: '8px',
textTransform: 'uppercase',
letterSpacing: '0.05em'
},
specValue: {
color: '#ffffff',
fontSize: '0.95rem',
lineHeight: '1.5'
},
button: {
backgroundColor: '#400684',
color: '#ffffff',
padding: '12px 24px',
borderRadius: '6px',
border: 'none',
fontFamily: 'Oswald, sans-serif',
fontSize: '1rem',
fontWeight: 'bold',
cursor: 'pointer',
transition: 'all 0.3s ease',
alignSelf: 'flex-start',
position: 'relative',
overflow: 'hidden',
'@media (max-width: 768px)': {
alignSelf: 'center',
width: '100%',
maxWidth: '300px'
},
':hover': {
backgroundColor: '#4338ca',
transform: 'translateY(-2px)',
boxShadow: '0 4px 15px rgba(79, 70, 229, 0.4)'
},
':active': {
transform: 'translateY(0)',
boxShadow: '0 2px 10px rgba(79, 70, 229, 0.4)'
},
'::before': {
content: '""',
position: 'absolute',
top: '50%',
left: '50%',
width: '0',
height: '0',
backgroundColor: 'rgba(255, 255, 255, 0.2)',
borderRadius: '50%',
transform: 'translate(-50%, -50%)',
transition: 'width 0.6s ease-out, height 0.6s ease-out'
},
':hover::before': {
width: '300px',
height: '300px'
}
},
glowingBorder: {
position: 'absolute',
top: '-2px',
left: '-2px',
right: '-2px',
bottom: '-2px',
borderRadius: '8px',
background: 'linear-gradient(45deg, #4f46e5, #06b6d4)',
opacity: 0,
transition: 'opacity 0.3s ease',
zIndex: -1
}
};

const product = products.find(p => p.id === productId);

if (!product) {
return (
<div style={styles.mainContainer}>
<div style={styles.overlay}></div>
<div style={styles.content}>Product not found</div>
</div>
);
}

return (
<div style={styles.mainContainer}>
<div style={styles.overlay}></div>
<div style={styles.content}>
<div style={styles.productGrid}>
<div style={styles.textContent}>
<h1 style={styles.title}>{product.name}</h1>
<h2 style={styles.subtitle}>Industrial Router</h2>
{isMobile ? (
<p 
style={{...styles.description, ...styles.mobileDescription}}
onClick={() => alert(product.description)}
>
{truncateDescription(product.description)}
</p>
) : (
<p style={styles.description}>{product.description}</p>
)}
<button
style={styles.button}
onMouseEnter={(e) => {
e.currentTarget.querySelector('.glowing-border').style.opacity = '1';
}}
onMouseLeave={(e) => {
e.currentTarget.querySelector('.glowing-border').style.opacity = '0';
}}
onClick={() => {
console.log('Inquiry button clicked');
}}
>
<div style={styles.glowingBorder} className="glowing-border"></div>
INQUIRE NOW
</button>
</div>

<div style={styles.imageContainer}>
<img 
src={product.image} 
alt={product.name}
style={styles.productImage}
/>
<img 
src={product.image} 
alt={`${product.name} shadow`}
style={styles.shadowImage}
/>
</div>
</div>

<div style={styles.specificationsGrid}>
{Object.entries(product.specifications).map(([key, value]) => (
<div key={key} style={styles.specificationCard}>
<div style={styles.specTitle}>{key}</div>
<div style={styles.specValue}>{value}</div>
</div>
))}
</div>
</div>
</div>
);
};

export default ProductDetail;